import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const chapters = [
  {
    n: "01",
    title: "See the future of surveillance",
    body: "Live demos of the latest CCTV, IP cameras, NVRs and analytics from the brands that define the industry.",
  },
  {
    n: "02",
    title: "Experience products first-hand",
    body: "Touch, test and compare. Talk to product experts, evaluate real hardware and get answers on the spot.",
  },
  {
    n: "03",
    title: "Grow your network & business",
    body: "Meet manufacturers, distributors and integrators. Discover pricing, partnerships and training opportunities.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative overflow-hidden bg-ink py-24 md:py-32" data-testid="manifesto">
      {/* Editorial marquee */}
      <div className="mb-20 border-y border-white/10 py-6">
        <Marquee speed={30} gradient={false} direction="right">
          <span className="mx-8 font-display text-4xl font-medium tracking-tight text-white/10 md:text-6xl">
            SEE IT · EXPERIENCE IT · GROW TOGETHER · SEE IT · EXPERIENCE IT · GROW TOGETHER ·&nbsp;
          </span>
        </Marquee>
      </div>

      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-16 max-w-2xl">
          <span className="overline text-orange">Why visit</span>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tighter text-white sm:text-5xl">
            Three reasons to be there.
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-white/10 bg-white/10 md:grid-cols-3">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group flex flex-col gap-6 bg-ink p-8 transition-colors duration-500 hover:bg-card md:p-10"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="font-mono-tech text-sm text-orange">{c.n}</span>
              <h3 className="font-display text-2xl font-medium leading-tight text-white">{c.title}</h3>
              <p className="font-sans text-sm leading-relaxed text-muted-foreground">{c.body}</p>
              <span className="mt-auto h-px w-full origin-left scale-x-0 bg-orange transition-transform duration-500 group-hover:scale-x-100" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
